// extracted by mini-css-extract-plugin
export default {"gradientButton":"GradientButton_gradientButton__dDNjq","gradientMove":"GradientButton_gradientMove__2HqKu"};